import qs from "qs";
import axios from "axios";
import { URL, API_URL } from "../../../../constants/Constants";

/**
 * Inserta control de pieza
 * @param {string} po - Purchase Order (requerido)
 * @param {string} mo - Manufacturing Order (requerido)
 * @param {string} usuario - Usuario que realiza la operación (requerido)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {string} fecha - Fecha de la operación
 * @param {string} movimiento - Movimiento (requerido): "Entregado.", "Recibido.", "EntraPiedras", "SalidaPiedras"
 * @param {number} currentScreenId - ID de la pantalla actual (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertControlDePieza = async (
  po,
  mo,
  usuario,
  typeConnect,
  fecha,
  movimiento,
  currentScreenId
) => {
  const queryData = {
    screen: "parts_movements",
    action: "insert",
    po: po,
    mo: mo,
    usuario: usuario,
    movimiento: movimiento,
  };

  // Agregar fecha solo si se proporciona
  if (fecha) {
    queryData.fecha = fecha;
  }

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
